<!--
// app/components/glossary/GlossaryConceptItem.vue
-->
<script setup lang="ts">
type Props = {
  id: string;
  title: string;
  definition: string;
  isHighlighted?: boolean;
};

defineProps<Props>();
</script>

<template>
  <div
    :id="id"
    :class="[
      'glossary-concept-item py-4 px-2 rounded transition-all duration-300 scroll-mt-4',
      isHighlighted ? 'bg-mercato/10 ring-2 ring-mercato' : '',
    ]"
  >
    <h4 class="text-white font-semibold text-base mb-2">{{ title }}</h4>
    <div class="text-gray-300 text-sm leading-relaxed" v-html="definition"></div>
  </div>
</template>

<style scoped>
.glossary-concept-item :deep(strong) {
  @apply text-mercato font-semibold;
}

.glossary-concept-item :deep(ul) {
  @apply list-disc pl-5 mt-2 mb-2;
}

.glossary-concept-item :deep(li) {
  @apply mb-1;
}

.glossary-concept-item :deep(br) {
  @apply block mb-2;
}
</style>
